import { css } from '@emotion/react'

import { Link as RouterLink } from 'react-router-dom'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
// @reach/dialog no es compatible con React 18, usar Modal de Chakra UI en su lugar
// import { Dialog as ReachDialog } from '@reach/dialog'
import { FaSpinner } from 'react-icons/fa'
import * as colors from '../styles/colors'
import * as mq from '../styles/media-queries'


const WrapperMain = styled.main({
    minHeight: 'calc(100vh - 60px)',
    position: 'inherit',
    margin: '60px 0 0 240px',
    background: '#edf1f5',
    [mq.small]: {
        margin: '60px 0 0 0'
    }
});

const Container = styled.div`
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 15px;
    padding-top: 10px;
`

const spin = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
})

const CircleButton = styled.button({
    borderRadius: '30px',
    padding: '0',
    width: '40px',
    height: '40px',
    lineHeight: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.base,
    color: colors.text,
    border: `1px solid ${colors.gray10}`,
    cursor: 'pointer',
})

const ButtonIcon = styled.div`
    background: transparent;
    cursor: pointer;
`;

const TableResponsive = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    table {
        background: white;
        width: 100%;
        max-width: 100%;
        margin-bottom: 10px;
        border-spacing: 0;
        border-collapse: collapse;
        border-bottom: 1px solid ${colors.gray80};
        thead > tr > th {
            vertical-align: bottom;
            background-color: ${colors.gray20};
            border-bottom: 1px solid #e4e7ea;
            padding: 15px 8px;
            font-weight: 500;
            text-align: left;
        }
        tbody > tr > td {
            border-top: 1px solid #e4e7ea;
            padding: 11px 8px;
            vertical-align: top;
            text-align: left;
            font-size: 14px;
            color: ${colors.gray80}
        }
    }
`

const Spinner = styled(FaSpinner)({
    animation: `${spin} 1s linear infinite`,
})

Spinner.defaultProps = {
    'aria-label': 'loading',
}

const buttonVariants = {
    primary: {
        background: colors.primary,
        color: colors.base,
    },
    primaryDark: {
        background: colors.bluedark,
        color: colors.base,
    },
    black: {
        background: colors.black,
        color: colors.base,
    },
    secondary: {
        background: colors.secondary,
        color: colors.base,
    },
    default: {
        background: colors.gray20,
        color: colors.text,
    },
    danger: {
        background: colors.danger,
        color: colors.base,
    },
}

const buttonSize = {
    xs: {
        fontSize: '0.9rem',
        padding: '5px 8px', 
    },
    sm: {
        fontSize: '0.9rem',
        padding: '8px 10px', 
    },
    md: {
        fontSize: '1rem',
        padding: '10px 15px', 
    },
    lg: {
        fontSize: '1.15rem',
        padding: '10px 18px', 
    }
}

const Button = styled.button(
    {
        position: 'relative',
        overflow: 'hidden',
        padding: '10px 15px',
        border: '0',
        lineHeight: '1',
        borderRadius: '3px',
        cursor: 'pointer'
    },
    ({m = 0}) => css`margin:${m}`,
    ({ variant = 'default' }) => buttonVariants[variant],
    ({ size = 'md' }) => buttonSize[size],
    ({disabled}) => disabled && css`::after {
                                        content: ' ';
                                        width: 100%;
                                        left: 0;
                                        top: 0;
                                        bottom: 0;
                                        right: 0;
                                        position: absolute;
                                        background: #ffffff40;
                                    }`,
    ({isLoading}) => isLoading && css`
    padding-left: 33px;
    &::before {
        content: ' ';
        display: block;
        border: 3px solid rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        border-top-color: white;
        opacity: 1;
        position: absolute;
        left: 5%;
        top: 25%;
        bottom: 25%;
        margin: auto;
        width: 16px;
        height: 16px;
        transition: opacity 200ms;
        animation: ${spin} 1s linear infinite;
        transition-delay: 200ms
    }
  `
)

const inputStyles = {
    // border: '1px solid #f1f1f4',
    // background: '#f1f2f7',
    // padding: '8px 12px',
    // width: '100%',
    // boxSizing: 'border-box',
    // transition: '.5s all ease-out',
    // fontSize: '15px'
    position: 'relative',
    overflow: 'hidden',
    // padding: '10px 15px',
    // margin: '0 5px 5px 0',
    fontSize: '0.9rem',
    border: '0',
    lineHeight: '1',
    borderRadius: '3px',
    cursor: 'pointer',
    background: 'none',
    color: 'blue',
}

const Input = styled.input({ borderRadius: '3px' }, inputStyles)
const Textarea = styled.textarea(inputStyles)
const Select = styled.select({ borderRadius: '3px' }, inputStyles)
const Label = styled.label({
    width: '100%',
    display: 'block',
    fontSize: '.9rem',
    color: colors.gray80,
    marginBottom: '4px'
});


const InputFilter = styled.input({
    border: '1px solid #f1f1f4',
    background: '#fff',
    padding: '8px 12px',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '3px',
    transition: '.5s all ease-out',
    fontSize: '15px'
});

const TitleFilter = styled.div`
    width: 100%;
    color: ${colors.gray90};
    margin-bottom: 5px;
    text-transform: uppercase;
    font-size: 1rem;
`

// TODO: Reemplazar con Modal de Chakra UI
// const Dialog = styled(ReachDialog)({
//     maxWidth: '450px',
//     borderRadius: '3px',
//     paddingBottom: '3.5em',
//     boxShadow: '0 10px 30px -5px rgba(0, 0, 0, 0.2)',
//     margin: '20vh auto',
//     [mq.small]: {
//         width: '100%',
//         margin: '10vh auto',
//     },
// })

const FormGroup = styled.div({
    display: 'flex',
    flexDirection: 'column',
})

/** NAVBAR **/
const Navbar = styled.nav`
    position: fixed;
    right: 0;
    top: 0;
    width: calc(100% - 240px);
    z-index: 1010;
    .navbar-header {
        width: 100%;
        padding: 5px;
        height: 60px;
        background: ${colors.primary};
        display: flex;
        justify-content: space-between;
        ul {
            li {
                padding: 3px 5px;
            }
        }
        button.toggle-sidebar {
            background: none;
            border: none;
            cursor: pointer;
            color: white;
            :focus {
                outline: none;
            }
        }
    }
    ${mq.small} {
        left: 0;
        width: 100%;
    }
`

/** NAVBAR DROPDOWN  **/
const DropDownMenu = styled.ul`

  /* main UL component called: "Menu" */
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: transparent;

  /* main LI */
  & > li {
    float: left;

    & > a, > button {
      position: relative;
      display: inline-block;
      color: ${colors.base};
      text-align: center;
      padding: 14px 20px 14px 16px;
      text-decoration: none;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 15px;
      &::after {
            content: '';
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translateY(-50%); 
            width: 0; 
            height: 0; 
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #fff;
            transition: all .3s ease-out;
      }
      &:focus {
        outline: none;
      }
    }
  }

  /* dropdown LI */
  & > .dropdown {
      display: inline-block;
      padding: 5px;
      & > .dropdown-content {
        display: none;
        position: absolute;
        top: 100%;
        right: 10px;
        background-color: ${colors.base};
        min-width: 110px;
        border: 1px solid #cacaca;
        z-index: 1;

        & > a, button {
          color: black;
          padding: 12px 16px;
          text-decoration: none;
          display: block;
          text-align: left;
          border: none;
          width: 100%;
          font-size: 14px;
          background-color: ${colors.base};
          &:hover {
            background-color: ${colors.gray20};
            cursor: pointer;
          }
        }
      }

      &.opened { 
        & > button {
            &::after {
                content: '';
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%) rotate(180deg);
            }
        }
        .dropdown-content {
            display: block
        }
      }
    }
`

/** SIDEBAR **/
const Sidebar = styled.div`
    background: #fff;
    border-right: 1px solid ${colors.gray20};
    position: fixed;
    width: 240px;
    padding-top: 0;
    top: 0;
    height: 100%;
    transition: .6s ease-out;
    z-index: 900;
    left: 0;
    transform: ${props => props.visible ? 'translateX(0)' : 'translateX(-240px)'};
    overflow-y: scroll;
    overflow-x: hidden;
`

const SidebarHead = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 240px;
    height: 60px;
    z-index: 10;
    text-transform: uppercase;
    border-bottom: 1px solid ${colors.gray20}
`

const SidebarListItems = styled.ul`
    list-style: none;
    padding: 0;
    overflow: hidden;
    margin-top: 60px;
    li {
        position: relative;
        display: block;
        a {
            position: relative;
            padding: 15px 35px 15px 20px;
            display: block;
            font-size: 14px;
            overflow: hidden;
            transition: .05s ease-in;
            .icon {
                width: 38px;
                display: inline-block;
                text-align: center!important;
                font-style: normal;
                font-weight: 500;
                margin-right: 7px;
                font-size: 16px;
                vertical-align: middle;
            }
            &:hover {
                background: rgba(0, 0, 0, 0.07);
                text-decoration: none;
            }
        }
        div.item-collapse {
            button {
                background: transparent;
                width: 100%;
                border: none;
                padding: 15px 35px 15px 20px;
                display: block;
                font-size: 14px;
                overflow: hidden;
                text-align: left;
                cursor: pointer;
                transition: .05s ease-in;
                img.icon {
                    width: 38px;
                    display: inline-block;
                    text-align: center!important;
                    font-style: normal;
                    font-weight: 500;
                    margin-right: 7px;
                    font-size: 16px;
                    vertical-align: middle;
                }
                &:hover {
                    background: rgba(0, 0, 0, 0.07);
                    text-decoration: none;
                }
                &:focus {
                    outline: none;
                }
            }
            ul {
                background-color: ${colors.gray20}
            }
        }
    }
`

const ErrorText = styled.div`
    color: ${colors.danger};
    font-size: .9rem;
    margin-top: 7px;
`


const linkVariants = {
    primary: {
        color: colors.indigo
    },
    black: {
        color: colors.black
    },
    danger: {
        color: colors.danger
    }
};

const Link = styled.a`
    &:hover,
    &:focus {
        text-decoration: underline;
        cursor: pointer;
        outline: none;
    }
    ${({ variant = 'primary' }) => linkVariants[variant]}
    ${({m = 0}) => `margin:${m}`}
`
const LinkButton = styled.button`
    background-color: transparent;
    border: none;
    font-size: 16px;
    &:hover,
    &:focus {
        text-decoration: underline;
        cursor: pointer;
        outline: none;
    }
    ${({ variant = 'primary' }) => linkVariants[variant]}
    ${({m = 0}) => `margin:${m}`}
`

const LinkItem = styled.button`
    background-color: transparent;
    border: none;
    font-size: 13px;
    cursor: pointer;
`;

const MenuList = styled.div`
    border: 1px solid #cacaca;
`;

const StyleInfoPatient = {
    color: colors.gray80,
    fontSize: '0.95rem',
    paddingTop: '6px',
    lineHeight: '20px'
}

const StyleDiagnosticState = {
    activo: {
        color: colors.base,
        backgroundColor: colors.blue,
        borderRadius: '5px',
        padding: '0 4px'
    },
    confirmado: {
        color: colors.base,
        backgroundColor: colors.bluedark,
        borderRadius: '5px',
        padding: '0 4px'
    },
    hipotesis_diagnostica: {
        color: colors.base,
        backgroundColor: colors.gray80,
        borderRadius: '5px',
        padding: '0 4px'
    },
    recuperado: {
        color: colors.base,
        backgroundColor: colors.yellow,
        borderRadius: '5px',
        padding: '0 4px'
    },
    dado_alta: {
        color: colors.base,
        backgroundColor: colors.green,
        borderRadius: '5px',
        padding: '0 4px'
    },
    descartado: {
        color: colors.base,
        backgroundColor: colors.danger,
        borderRadius: '5px',
        padding: '0 4px'
    }
}

const errorMessageVariants = {
    stacked: { display: 'block' },
    inline: { display: 'inline-block' },
}

function ErrorMessage({ error, variant = 'stacked', ...props }) {
    return (
        <div role="alert" css={[{ color: colors.danger }, errorMessageVariants[variant]]} {...props}>
            <span>There was an error: </span>
            <pre css={[errorMessageVariants[variant]]}>
                {error.message}
            </pre>
        </div>
    )
}

function FullPageErrorFallback({ error }) {
    return (
        <div style={{ color: colors.danger, height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <p>Hubo un error. Intente actualizar la página.</p>
            <pre>{error.message}</pre>
        </div>
    )
}

export {
    FullPageErrorFallback,
    ErrorMessage,
    ErrorText,
    WrapperMain,
    Container,
    CircleButton,
    TableResponsive,
    Spinner,
    Button,
    ButtonIcon,
    InputFilter,
    TitleFilter,
    Input,
    Select,
    Textarea,
    Navbar,
    Sidebar,
    SidebarHead,
    SidebarListItems,
    Label,
    // Dialog, // Comentado - usar Modal de Chakra UI
    FormGroup,
    DropDownMenu,
    Link,
    LinkButton,
    LinkItem,
    MenuList,
    StyleInfoPatient,
    StyleDiagnosticState
}